import request from '@/utils/request'

const baseUrl = process.env.VUE_APP_PURCHASE_API

// 分页查询申请单列表
export function getPurchaseApplyListApi(params) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-requirements/page`,
    method: 'get',
    params
  })
}

// 通过id查询申请单详情
export function getPurchaseApplyDetailApi(requirementId) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-requirements/${requirementId}/detail`,
    method: 'get'
  })
}

// 删除已保存的项目
export function deletePurchaseApplyApi(requirementId) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-requirements/${requirementId}`,
    method: 'delete'
  })
}

// 保存申请单（新增）
export function addStorePurchaseApplyApi(data) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-requirements`,
    method: 'post',
    data
  })
}

// 批量导入--申请单品目
export function importApplyMaterialInfoApi(data) {
  return request(
    {
      url: `${baseUrl}/workbench/demander/purchase-requirements/import`,
      method: 'post',
      data,
      headers: { 'Content-Type': 'multipart/form-data' }
    },
    true,
    true
  )
}

// 保存申请单（编辑）
export function editStorePurchaseApplyApi(data) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-requirements/${data.requirementId}`,
    method: 'put',
    data
  })
}

// 提交申请单（新增）
export function addPublishPurchaseApplyApi(data) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-requirements/apply`,
    method: 'post',
    data
  })
}

// 提交申请单（编辑）
export function editPublishPurchaseApplyApi(data) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-requirements/${data.requirementId}/apply`,
    method: 'put',
    data
  })
}
